// extracted by mini-css-extract-plugin
export var capleft = "blog-hero-module--capleft--a5a95";
export var capright = "blog-hero-module--capright--2bc9d";
export var caption = "blog-hero-module--caption--9102b";
export var copy_body = "blog-hero-module--copy_body--8981e";
export var copy_cta = "blog-hero-module--copy_cta--ed4d2";
export var hcaption = "blog-hero-module--hcaption--3b29c";
export var hero = "blog-hero-module--hero--f0ef4";
export var hero_a_center = "blog-hero-module--hero_a_center--4ed0a";
export var hero_a_right = "blog-hero-module--hero_a_right--5a1a2";
export var hero_ma_center = "blog-hero-module--hero_ma_center--94ef9";
export var hero_ma_right = "blog-hero-module--hero_ma_right--476f9";
export var hero_pad = "blog-hero-module--hero_pad--f0110";
export var hero_stamp = "blog-hero-module--hero_stamp--1bc3c";
export var hero_vid = "blog-hero-module--hero_vid--2f945";
export var image = "blog-hero-module--image--88d08";
export var img = "blog-hero-module--img--192b6";
export var overlay = "blog-hero-module--overlay--fec13";
export var pdp = "blog-hero-module--pdp--a3014";
export var pg_capt = "blog-hero-module--pg_capt--2ee30";
export var title = "blog-hero-module--title--001b0";
export var title_link = "blog-hero-module--title_link--849b1";
export var use_caslon = "blog-hero-module--use_caslon--90349";
export var use_mason = "blog-hero-module--use_mason--78f84";
export var use_proxw = "blog-hero-module--use_proxw--3e831";
export var wide = "blog-hero-module--wide--19654";